<app-dialog-header [title]="isEditMode ? 'ENGAGE.POSTING.HEADER_EDIT' : 'ENGAGE.POSTING.HEADER'" (onClick)="dialogRef.close(null)"></app-dialog-header>

<div fxLayout="column" fxLayoutAlign="start" class="p-24 pb-0 new-posting-container">
    <form name="new-posting" [formGroup]="formGroup">
        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="6%">
            <mat-form-field formGroupName="postingType" fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-label>
                <mat-select formControlName="type">
                    <mat-option [value]="postingType.id" *ngFor="let postingType of formTypes">{{ postingType.displayNameKeySingular | translate }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field fxFlex.gt-xs="1 0 47%" formGroupName="translations" [class.readonly]="postingFromArticle">
                <mat-label>{{ 'GENERAL.PROPERTY.LANGUAGE' | translate }}</mat-label>
                <mat-select formControlName="language">
                    <mat-option *ngFor="let lang of languageService.languages | filterLanguages" [value]="lang.id">
                        <span fxLayout="row" fxLayoutAlign="start center">
                            <img alt="" class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                            <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                        </span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="posting-image-wrapper mb-24">
            <div *ngIf="!maxBrainImageSelected || !maxBrainImageSelected.url" class="posting-image-container" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="preview-container pointer" fxLayout="row" fxLayoutAlign="center center" (click)="openImageLibraryDialog()">
                    <div class="preview-bg-container">
                        <div class="img-icon"></div>
                        <div class="preview-title">
                            {{ 'IMAGE_LIBRARY.DIALOG.LABELS.IMAGE_PREVIEW' | translate }}
                        </div>
                    </div>
                </div>
                <div fxLayout="column" class="ml-24">
                    <app-white-button class="mr-8 mb-28" [label]="'IMAGE_LIBRARY.BUTTONS.SELECT_IMAGE'" (onClick)="openImageLibraryDialog()"></app-white-button>
                    <p class="about-image-upload">
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_RECCOMENDED_DIMENSTION' | translate }}
                        <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_SUPPORTED_FORMATS' | translate }} <br />
                        {{ 'ENGAGE.HOME_EXPERIENCE_BANNER.LABELS.IMAGE_MAX_FILE_SIZE' | translate }}
                    </p>
                    <mat-error *ngIf="formGroup.dirty && controls.img.hasError('required')">
                        {{ 'ERROR.RESPONSE.' + 'required' | translate }}
                    </mat-error>
                </div>
            </div>
            <div *ngIf="maxBrainImageSelected && maxBrainImageSelected.url" class="posting-image-container" fxLayout="row" fxLayoutAlign="flex-start center">
                <div class="posting-image-bg pointer" (click)="openImageLibraryDialog()" [style.background-image]="'url(' + maxBrainImageSelected.url + ')'"></div>
                <img style="display: none" *ngIf="maxBrainImageSelected.unsplash" [src]="unsplashViewsBaseUrl + maxBrainImageSelected.unsplash.unsplashId" />
                <div fxLayout="column" class="ml-48" *ngIf="postingType?.name !== 'article'">
                    <app-white-button class="mr-8 mb-28" [label]="'IMAGE_LIBRARY.BUTTONS.CHANGE_IMAGE'" (onClick)="openImageLibraryDialog()"></app-white-button>
                </div>
            </div>
        </div>

        <div formGroupName="translations">
            <mat-form-field class="w-100-p mb-12" [class.readonly]="postingFromArticle">
                <mat-label>{{ 'ENGAGE.POSTING.LABELS.TITLE' | translate }}</mat-label>
                <input matInput name="title" formControlName="title" maxlength="150" />
                <mat-hint align="end">{{ controls.title.value?.length || 0 }}/150</mat-hint>
                <mat-error *ngIf="controls.title.touched && controls.title.hasError('required')">
                    {{ 'ERROR.RESPONSE.' + 'required' | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100-p" *ngIf="postingFromArticle; else tinyMce" [class.readonly]="postingFromArticle">
                <mat-label>{{ 'ENGAGE.POSTING.SHORT_DESCRIPTION' | translate }}</mat-label>
                <textarea
                    rows="5"
                    matInput
                    name="description"
                    formControlName="description"
                    maxlength="500"
                ></textarea>
                <mat-hint align="end">{{ controls.description.value?.length || 0 }}/{{ textEditorCharacterLimit }}</mat-hint>
            </mat-form-field>

            <ng-template #tinyMce>
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p description-preview-field">
                    <mat-label>{{ 'ENGAGE.POSTING.SHORT_DESCRIPTION' | translate }}</mat-label>

                    <!-- Keep a real MatFormFieldControl in the DOM, but visually hide it. -->
                    <textarea
                        matInput
                        formControlName="description"
                        class="description-hidden-control"
                        tabindex="-1"
                        aria-hidden="true"
                    ></textarea>

                    <div
                        class="posting-description"
                        role="button"
                        tabindex="0"
                        (click)="editDescription()"
                        (keydown.enter)="editDescription()"
                        (keydown.space)="$event.preventDefault(); editDescription()"
                        [innerHTML]="formGroup.get('translations.description').value | safeHtml"
                    ></div>

                    <mat-hint align="end">{{ controls.description.value?.length || 0 }}/{{ textEditorCharacterLimit }}</mat-hint>
                    <mat-error *ngIf="controls.description.value?.length > textEditorCharacterLimit">
                        {{ 'GENERAL.MESSAGE.TOO_MANY_CHARACTERS' | translate: { total: textEditorCharacterLimit } }}
                    </mat-error>
                </mat-form-field>
            </ng-template>
        </div>

        <mat-form-field class="w-100-p">
            <mat-label>{{ 'ENGAGE.POSTING.URL' | translate }}</mat-label>
            <input type="url" matInput name="url" formControlName="url" />
            <mat-error *ngIf="controls.description.touched && controls.url.hasError('required')">
                {{ 'ERROR.RESPONSE.' + 'required' | translate }}
            </mat-error>
            <mat-error *ngIf="controls.description.touched && controls.url.hasError('pattern')">
                {{ 'ERROR.RESPONSE.' + 'invalid_url' | translate }}
            </mat-error>
        </mat-form-field>

        <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="0" fxLayoutGap.gt-xs="6%" *ngIf="isEditMode">
            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.VALID_FROM' | translate }}</mat-label>
                <input
                    matInput
                    [matDatepicker]="pickerValidFrom"
                    formControlName="validFrom"
                    (focus)="pickerValidFrom.open()"
                    (ngModelChange)="updateEndDate()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerValidFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerValidFrom></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="1 0 100%" fxFlex.gt-xs="1 0 47%">
                <mat-label>{{ 'GENERAL.PROPERTY.VALID_TO' | translate }}</mat-label>
                <input
                    matInput
                    formControlName="validTo"
                    [min]="minDate"
                    [matDatepicker]="pickerValidTo"
                    (focus)="pickerValidTo.open()"
                />
                <mat-datepicker-toggle matSuffix [for]="pickerValidTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerValidTo></mat-datepicker>
            </mat-form-field>
        </div>
    </form>
</div>

<div class="pt-24 action-buttons">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button
        [label]="'GENERAL.BUTTON.SAVE'"
        (onClick)="createPosting()"
        [disabled]="formGroup.invalid || controls.description.value?.length > textEditorCharacterLimit"
    ></app-flat-button>
</div>
